<template>
  <div class="card">
    <div class="card-header">
      <h5>Aktuelle Meldungen</h5>
    </div>
    <div class="card-body">
      <b-row>
        <b-col md="12" class="list_mode iam-table-ux">
          <b-input-group class="datatable-btn">
            <div>
              <b-form-input style="border:1px solid lightgrey" v-model="filter.allMessages" placeholder="Suchen"></b-form-input>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
      <Loader v-if="loading" />
      <transition
        :name="animations.fadeIn.name"
        :enter-active-class="animations.fadeIn.enter"
        :leave-active-class="animations.fadeIn.leave"
        mode="out-in"
      >
        <div class="table-responsive datatable-vue" v-if="boardsReady && !loading && ready.users">
          <b-table
            show-empty
            :items="allMessages"
            :fields="tablefields.allMessages"
            :filter="filter.allMessages"
            :current-page="currentPage.allMessages"
            :per-page="perPage.allMessages"
            @filtered="filteredMessages"
            sort-by="created_on"
            sort-desc
          >
            <template slot="empty">
              <div class="text-center">
                Keine Meldungen gefunden.
              </div>
            </template>
            <template v-slot:cell(owner)="row">
              {{ kundeName(row.item.owner) }}
            </template>
            <template v-slot:cell(created_on)="row">
              {{ transformDate(row.item.created_on) }}
            </template>
            <template v-slot:cell(aktion)="row">
              <feather :id="'edit_message_' + row.item.id" type="edit-2" class="infra-blue pointer" @click="openModalEdit(row.item)"></feather>
              <b-tooltip :target="'edit_message_' + row.item.id" triggers="hover" placement="left">Empfänger bearbeiten</b-tooltip>
              <feather
                :id="'delete_message_' + row.item.id"
                type="trash"
                class="infra-blue pointer"
                style="margin-left:10px;"
                @click="openModalDelete(row.item)"
              ></feather>
              <b-tooltip :target="'delete_message_' + row.item.id" triggers="hover" placement="left">Löschen</b-tooltip>
            </template>
            <template v-slot:cell(priority)="row">
              <div class="preview_badges">
                <span class="badge badge-success" v-if="row.item.priority == 'niedrig'">Info</span>
                <span class="badge badge-info" v-if="row.item.priority == 'normal'">Meldung</span>
                <span class="badge badge-warning" v-if="row.item.priority == 'hoch'">Wichtig</span>
              </div>
            </template>
            <template v-slot:cell(per_mail)="row">
              <feather
                :id="'mail_icon_' + row.item.id"
                type="mail"
                size="20"
                v-if="row.item.per_mail"
                class="infra-blue"
                style="vertical-align:top;"
              ></feather>
              <b-tooltip :target="'mail_icon_' + row.item.id" triggers="hover" v-if="row.item.per_mail" placement="left"
                >wurde per Mail versandt</b-tooltip
              >
            </template>
          </b-table>
          <b-col md="6" class="my-1" style="margin-top:15px!important;padding-left:0px!important;" v-if="totalRows.allMessages > perPage.allMessages">
            <b-pagination
              v-model="currentPage.allMessages"
              :total-rows="totalRows.allMessages"
              :per-page="perPage.allMessages"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </transition>
      <div class="flex-row-end" style="margin-top:30px;">
        <b-button class="btn btn-primary" @click="$bvModal.show('sendBoardMessage')">Meldung hinzufügen</b-button>
      </div>
      <!-- Modal Edit Message -->
      <b-modal id="editBoardMessage" @cancel="closeModalEdit" @hide="hideModal" @ok="processModalChanges" size="lg">
        <div class="container-fluid">
          <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
            <div id="backButton" class="infra-blue" v-if="tableStep > 0" @click="goBack">
              <feather type="arrow-left" class="infra-blue pointer" size="30"></feather>
            </div>
          </transition>
          <b-tabs>
            <!-- Tab Bauprojekte -->
            <b-tab title="Bauprojekte" :active="activeTab == 0">
              <div class="table-responsive datatable-vue" v-if="tableStep == 0">
                <b-table
                  show-empty
                  :items="bauprojekte"
                  :fields="tablefields.bauprojekte"
                  :filter="filter.bauprojekte"
                  :current-page="currentPage.bauprojekte"
                  :per-page="perPage.bauprojekte"
                  @filtered="filteredBauprojekte"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(goHouses)="row">
                    <transition
                      :name="animations.standard.name"
                      :enter-active-class="animations.standard.enter"
                      :leave-active-class="animations.standard.leave"
                      mode="out-in"
                    >
                      <feather
                        v-if="!isSelected({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                        type="arrow-right"
                        class="pointer infra-blue"
                        size="25"
                        @click="goHouses(row.item)"
                        :key="row.item.id + 'arrowbp'"
                      ></feather>
                      <feather v-else type="check" class="green" size="25" :key="row.item.id + 'checkbp'"></feather>
                    </transition>
                  </template>
                </b-table>
              </div>
              <!-- table hauser -->
              <div class="table-responsive datatable-vue" v-if="tableStep == 1">
                <b-table
                  show-empty
                  :items="tableSelected.bp.extended.hauser"
                  :fields="tablefields.hauser"
                  :filter="filter.hauser"
                  :current-page="currentPage.hauser"
                  :per-page="perPage.hauser"
                  @filtered="filteredHauser"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'haus', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'haus', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(goWohnungen)="row">
                    <transition
                      :name="animations.standard.name"
                      :enter-active-class="animations.standard.enter"
                      :leave-active-class="animations.standard.leave"
                      mode="out-in"
                    >
                      <feather
                        v-if="!isSelected({ context: 'haus', id: row.item.id, name: row.item.name })"
                        type="arrow-right"
                        class="pointer infra-blue"
                        size="25"
                        @click="goWohnungen(row.item)"
                        :key="row.item.id + 'arrowHouse'"
                      ></feather>
                      <feather v-else type="check" class="green" size="25" :key="row.item.id + 'checkhouse'"></feather>
                    </transition>
                  </template>
                </b-table>
              </div>
              <!-- table wohnungen -->
              <div class="table-responsive datatable-vue" v-if="tableStep == 2">
                <b-table
                  show-empty
                  :items="tableSelected.haus.extended.wohnungen"
                  :fields="tablefields.wohnungen"
                  :filter="filter.wohnungen"
                  :current-page="currentPage.wohnungen"
                  :per-page="perPage.wohnungen"
                  @filtered="filteredWohnungen"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'wohnung', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'wohnung', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(wohnflaeche)="row"> {{ row.item.wohnflaeche }} m<sup>2</sup> </template>
                </b-table>
              </div>
            </b-tab>
            <!-- Tab Kunden -->
            <b-tab title="Kunden" :active="activeTab == 1">
              <b-row>
                <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-bottom:20px;">
                  <b-input-group class="datatable-btn">
                    <div>
                      <b-form-input style="border:1px solid lightgrey" v-model="filter.kunden" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- table kunden -->
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  :items="kunden"
                  :fields="tablefields.kunden"
                  :current-page="currentPage.kunden"
                  :per-page="perPage.kunden"
                  :filter="filter.kunden"
                  @filtered="filteredKunden"
                >
                  <template v-slot:cell(name)="row"> {{ row.item.first_name }} {{ row.item.last_name }} </template>
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'kunde', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'kunde', id: row.item.id, name: kundeName(row.item) })"
                      />
                    </div>
                  </template>
                </b-table>
              </div>
              <b-col md="6" class="my-1" v-if="totalRows.kunden > perPage.kunden">
                <b-pagination v-model="currentPage.kunden" :total-rows="totalRows.kunden" :per-page="perPage.kunden" class="my-0"></b-pagination>
              </b-col>
            </b-tab>
            <!-- Tab Dienstleister -->
            <b-tab title="Dienstleister" :active="activeTab == 2">
              <b-row>
                <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-bottom:20px;">
                  <b-input-group class="datatable-btn">
                    <div>
                      <b-form-input style="border:1px solid lightgrey" v-model="filter.dienstleister" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- Table Dienstleister -->
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  :items="dienstleister"
                  :fields="tablefields.dienstleister"
                  :current-page="currentPage.dienstleister"
                  :per-page="perPage.dienstleister"
                  :filter="filter.dienstleister"
                  @filtered="filteredDienstleister"
                >
                  <template v-slot:cell(name)="row"> {{ row.item.name }}</template>
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'dienstleister', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'dienstleister', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                </b-table>
              </div>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-if="totalRows.dienstleister > perPage.dienstleister"
                  v-model="currentPage.dienstleister"
                  :total-rows="totalRows.dienstleister"
                  :per-page="perPage.dienstleister"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-tab>
          </b-tabs>
        </div>
        <template slot="modal-cancel">Abbrechen</template>
        <template slot="modal-ok">Speichern</template>
        <template slot="modal-header"><h4>Meldung editieren</h4></template>
      </b-modal>
      <b-modal id="deleteBoardMessage" size="md" @ok="processDeletion" @hide="resetModalState" @cancel="closeModalDelete">
        <div class="container-fluid">
          Meldung wirklich löschen ?
        </div>
        <template slot="modal-ok">
          Löschen
        </template>
        <template slot="modal-cancel">
          Abbrechen
        </template>
        <template slot="modal-header">
          Meldung löschen
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminCurrentMeldungen",
  data() {
    return {
      loading: false,
      selected: [],
      tableStep: 0,
      activeTab: 0,
      deleteMessage: null,
      amountAllRecipients: 0,
      tableSelected: {
        bp: false,
        haus: false,
      },
      tablefields: {
        allMessages: [
          { key: "title", label: "Titel", sortable: false },
          { key: "owner", label: "von", sortable: true },
          { key: "created_on", label: "am", sortable: true },
          { key: "per_mail", label: "Mail", sortable: true },
          { key: "priority", label: "Priorität", sortable: true },
          { key: "aktion", label: "Aktion", sortable: false },
        ],
        kunden: [
          { key: "name", label: "Name", sortable: true },
          { key: "email", label: "Email", sortable: true },
          { key: "telefon", label: "Telefon", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: true },
        ],
        bauprojekte: [
          { key: "name", label: "Bauprojekt", sortable: true },
          { key: "extended.hauser.length", label: "Häuser", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
          { key: "goHouses", label: "zu Häusern", sortable: false },
        ],
        hauser: [
          { key: "name", label: "Haus", sortable: true },
          { key: "extended.wohnungen.length", label: "Wohnungen", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
          { key: "goWohnungen", label: "zu Wohnungen", sortable: false },
        ],
        wohnungen: [
          { key: "name", label: "Wohnung", sortable: true },
          { key: "wohnflaeche", label: "Wohnfläche", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: true },
        ],
        dienstleister: [
          { key: "name", label: "Firma", sortable: false },
          { key: "extended.branchenString", label: "Branchen", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
        ],
      },
      filter: {
        allMessages: null,
        kunden: null,
        bauprojekte: null,
        hauser: null,
        wohnungen: null,
        dienstleister: null,
      },
      totalRows: {
        allMessages: 1,
        kunden: 1,
        bauprojekte: 1,
        hauser: 1,
        wohnungen: 1,
        diensleister: 1,
      },
      currentPage: {
        allMessages: 1,
        kunden: 1,
        bauprojekte: 1,
        hauser: 1,
        wohnungen: 1,
        diensleister: 1,
      },
      perPage: {
        allMessages: 10,
        kunden: 10,
        bauprojekte: 10,
        hauser: 10,
        wohnunen: 10,
        dienstleister: 10,
      },
      pageOptions: {
        allMessages: [10, 50, 100],
        kunden: [10, 50, 100],
        bauprojekte: [10, 20, 50],
        hauser: [10, 50, 100],
        wohnungen: [10, 50, 100],
        dienstleister: [10, 50, 100],
      },
      msg: {
        title: "",
        body: "",
        priority: "normal",
        recipients: [],
        per_mail: false,
        status: "active",
        id: null,
      },
      msgDefault: {
        title: "",
        body: "",
        priority: "normal",
        recipients: [],
        per_mail: false,
        status: "active",
      },
    };
  },
  computed: {
    ...mapGetters({
      messages: "msg/messages",
      boardsReady: "msg/boardsReady",
      toasts: "app/toasts",
      animations: "app/animations",
      users: "app/users",
      allMessages: "msg/allMessages",
      ready: "app/readyState",
      bauprojekte: "app/bauprojekte",
      dienstleister: "app/dienstleister",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      kunden: "app/kunden",
    }),
  },
  components: {
    Loader,
  },
  async created() {
    if (!this.users.length) {
      try {
        await this.$store.dispatch("app/apiGetUsers");
      } catch (error) {
        console.log(error);
        throw "Error getting User List";
      }
    }

    this.loading = true;
    await this.setAllMessages();
    this.totalRows.allMessages = this.allMessages.length;
    this.totalRows.kunden = this.kunden.length;
    this.totalRows.diensleister = this.dienstleister.length;
    this.loading = false;
  },
  methods: {
    openModalEdit(msg) {
      this.msg = this.cloneNonReactive(msg);
      this.msg.recipients.forEach((rec) => {
        this.handleSelect(rec);
      });
      this.$bvModal.show("editBoardMessage");
    },
    openModalDelete(msg) {
      this.deleteMessage = msg;
      this.$bvModal.show("deleteBoardMessage");
    },
    hideModal() {
      this.resetModalState();
    },
    closeModalEdit() {
      this.$bvModal.hide("editBoardMessage");
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteBoardMessage");
    },
    async processDeletion() {
      if (this.deleteMessage === null) {
        this.$toasted.show("Fehler beim Löschen, Keine Nachricht zum Löschen gefunden.", this.toasts.failure);
        return;
      }

      try {
        await this.$store.dispatch("msg/deleteMessage", this.cloneNonReactive(this.deleteMessage));
        await this.$store.dispatch("msg/updateAllMessages");
        await this.setAllMessages();
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Löschen der Nachricht.");
      }
    },
    async processModalChanges() {
      const same = JSON.stringify(this.selected) === JSON.stringify(this.msg.recipients);
      if (same) return;
      let updateMessagePayload = this.cloneNonReactive(this.msg);
      updateMessagePayload.recipients = this.cloneNonReactive(this.selected);

      try {
        await this.$store.dispatch("msg/updateMessageRecipients", updateMessagePayload);
        await this.setAllMessages();
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Aktualisieren der Nachricht.", this.toasts.failure);
      }
    },
    isSelected(selection) {
      if (this.selected.find((el) => el.id == selection.id && el.context == selection.context)) return true;
      return false;
    },
    filteredKunden(filteredItems) {
      this.totalRows.kunden = filteredItems.length;
      this.currentPage.kunden = 1;
    },
    filteredBauprojekte(filteredItems) {
      this.totalRows.bauprojekte = filteredItems.length;
      this.currentPage.bauprojekte = 1;
    },
    filteredHauser(filteredItems) {
      this.totalRows.hauser = filteredItems.length;
      this.currentPage.hauser = 1;
    },
    filteredWohnungen(filteredItems) {
      this.totalRows.wohnungen = filteredItems.length;
      this.currentPage.wohnungen = 1;
    },
    filteredRecipients(filteredItems) {
      this.totalRows.recipients = filteredItems.length;
      this.currentPage.recipients = 1;
    },
    filteredDienstleister(filteredItems) {
      this.totalRows.dienstleister = filteredItems.length;
      this.currentPage.dienstleister = 1;
    },
    handleSelect(selected) {
      const idx = this.selected.findIndex((item) => item.id == selected.id && item.context == selected.context);
      if (idx > -1) {
        this.selected.splice(idx, 1);
        return;
      }
      this.selected.push(this.cloneNonReactive(selected));
    },
    kundeName(kunde) {
      return kunde.first_name + " " + kunde.last_name;
    },
    goHouses(bp) {
      this.tableSelected.bp = bp;
      this.tableStep = 1;
    },
    goWohnungen(haus) {
      this.tableSelected.haus = haus;
      this.tableStep = 2;
    },
    goBack() {
      switch (this.tableStep) {
        case 2:
          this.tableSelected.haus = false;
          this.tableStep = 1;
          break;
        case 1: {
          this.tableSelected.bp = false;
          this.tableStep = 0;
          break;
        }
      }
    },
    resetModalState() {
      this.msg = Object.assign({}, this.msgDefault);
      this.selected = [];
      this.modalStep = 0;
      this.tableStep = 0;
      this.amountAllRecipients = 0;
      this.deleteMessage = null;
    },
    getUserName(id) {
      const user = this.users.find((u) => {
        return u.id == id;
      });
      if (!user) return;
      return user.first_name + " " + user.last_name;
    },
    async setAllMessages() {
      const allMessagesMeta = [
        ...this.messages.bauprojekt,
        ...this.messages.haus,
        ...this.messages.wohnung,
        ...this.messages.kunde,
        ...this.messages.dienstleister,
      ];

      for (let i = 0; i < allMessagesMeta.length; i++) {
        if (this.allMessages.find((msg) => msg.id == allMessagesMeta[i].message_id) === undefined) {
          const id = allMessagesMeta[i].message_id;
          const message = this.cloneNonReactive(await this.getMessage(id));
          this.allMessages.push(message);
        }
      }
    },
    async getMessage(id) {
      let result = false;
      try {
        const response = await this.$directus.getItem("board_messages", id);
        result = response.data;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen der Meldungsliste.", this.toasts.failure);
      }

      return result;
    },
    filteredMessages(filteredItems) {
      this.totalRows.allMessages = filteredItems.length;
      this.currentPage.allMessages = 1;
    },
  },
};
</script>

<style scoped>
.loader {
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
  -moz-backdrop-filter: unset;
  background: transparent;
  position: relative !important;
}
</style>
